exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn[data-v-1eef62f2] {\r\n  margin-bottom: 4px;\n}\n.number-opcao[data-v-1eef62f2] {\r\n  font-weight: bold !important;\r\n  font-family: \"Helvetica\", \"Arial\", sans-serif;\r\n  border-color: #fff;\n}\n.btn-primary:hover.number-opcao[data-v-1eef62f2] {\r\n  color: #fff !important;\r\n  background-color: #0ae7ef !important;\r\n  border-color: #0ae7ef !important;\n}\n.btn-primary.active[data-v-1eef62f2]{\r\n  color: #fff !important;\r\n  background-color: #0ae7ef !important;\r\n  border-color: #0ae7ef !important;\n}\nstrong[data-v-1eef62f2] {\r\n  color: #535d67 !important;\n}\r\n", ""]);

// exports
